"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.types17 = void 0;
const types_12_1 = require("./types_12");
exports.types17 = Object.assign(Object.assign({}, types_12_1.types12), { 
    // Delegation updated types
    DelegationNode: {
        hierarchyRootId: "DelegationNodeIdOf",
        parent: "Option<DelegationNodeIdOf>",
        children: "BTreeSet<DelegationNodeIdOf>",
        details: "DelegationDetails",
    }, DelegationDetails: {
        owner: "DelegatorIdOf",
        revoked: "bool",
        permissions: "Permissions",
    }, DelegationHierarchyDetails: {
        ctypeHash: "CtypeHashOf",
    }, DelegationStorageVersion: {
        _enum: ["V1", "V2"],
    } });
